<template>
    <v-container>
    <v-card class="mb-9">
        <v-dialog v-model="dialog" max-width="765px">
            <v-card>
                <header class="v-card-header">
                    <img :src="vCardLogo" />
                    <v-card-title>{{ dialogItem.name }}</v-card-title>
                    <v-card-actions @click="dialog = !dialog">
                        <v-btn class="v-card-close">
                            <v-icon x-large color="#61aa35">mdi-close-box</v-icon>
                        </v-btn>
                    </v-card-actions>
                </header>
                <v-card-text>
                    <div class="v-card-column-wrapper">
                        <div class="v-card-column">
                            <h2>Description</h2>
                            <p>{{ dialogItem.details.business.description }}</p>
                            <h2 class="nested">Extra Information</h2> 
                            <div class="flag-icons">
                                <div v-for="flag in dialogItem.flags" :key="flag.name">
                                    <div v-if="flag.toggle && flag.name !== 'Open'" class="mb-3" style="display:flex;align-items:flex-start">
                                        <v-icon x-large primary v-on="on" class="mr-3">{{flag.icon}}</v-icon>
                                        <p>{{flag.name}} {{flag.description !== "" ? '-' + flag.description : ""}}</p>
                                    </div>
                                    <div v-else-if="flag.toggle && flag.name == 'Open'" class="mb-3" style="display:flex;align-items:flex-start">
                                        <v-icon x-large primary v-on="on" class="mr-3">{{flag.icon}}</v-icon>
                                        <p>{{flag.name}}</p>
                                    </div>
                                    <div v-else-if="!flag.toggle && flag.name == 'Open'" class="mb-3" style="display:flex;align-items:flex-start">
                                        <p>{{flag.description !== "" ? '-' + flag.description : ""}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>  
                        <div class="v-card-column">
                            <h2>Contact Details</h2>
                            <ul>
                                <li class="contact-name">{{ dialogItem.details.contact.firstname }} {{ dialogItem.details.contact.lastname }}</li>
                                <!-- <li class="contact-email"><a v-bind:href="'mailto:' + dialogItem.details.contact.email">{{ dialogItem.details.contact.email }}</a></li> -->
                                <li class="contact-phone">{{ dialogItem.details.contact.phone }}</li>
                                <li class="contact-url"><a :href="fixURL(dialogItem.details.contact.url)">{{dialogItem.details.contact.url}}</a></li>
                            </ul>
                            <h2 class="nested">Location</h2>
                            <ul>
                                <li class="contact-location">{{ dialogItem.details.business.address }}, {{ dialogItem.details.business.postcode }}</li>
                            </ul>
                            <h2 class="nested">Business Hours</h2>
                            <ul>
                                <li class="contact-hours">{{ dialogItem.details.business.hours }}</li>
                            </ul>
                             <h2 class="nested">Share</h2>
                            <ul>
                                    <!-- Sharingbutton Facebook -->
                                    <p>
                                    <a class="resp-sharing-button__link" :href="encodeURI('https://facebook.com/sharer/sharer.php?u=https://nzdemos-web.squiz.cloud/openforbiz/app%23/&amp;business='+encodeBusiness(dialogItem.name))" target="_blank" rel="noopener" aria-label="">
                                    <div class="resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.77 7.46H14.5v-1.9c0-.9.6-1.1 1-1.1h3V.5h-4.33C10.24.5 9.5 3.44 9.5 5.32v2.15h-3v4h3v12h5v-12h3.85l.42-4z"/></svg>
                                        </div>
                                    </div>
                                    </a>

                                    <!-- Sharingbutton Twitter --> 
                                    <a class="resp-sharing-button__link" :href="encodeURI('https://twitter.com/intent/tweet/?text=Checkout out '+ dialogItem.name +' on the Open for Business website!&url=https://nzdemos-web.squiz.cloud/openforbiz/app#?business='+encodeURIComponent(dialogItem.name))" target="_blank" rel="noopener" aria-label="">
                                    <div class="resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small"><div aria-hidden="true" class="resp-sharing-button__icon resp-sharing-button__icon--solid">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M23.44 4.83c-.8.37-1.5.38-2.22.02.93-.56.98-.96 1.32-2.02-.88.52-1.86.9-2.9 1.1-.82-.88-2-1.43-3.3-1.43-2.5 0-4.55 2.04-4.55 4.54 0 .36.03.7.1 1.04-3.77-.2-7.12-2-9.36-4.75-.4.67-.6 1.45-.6 2.3 0 1.56.8 2.95 2 3.77-.74-.03-1.44-.23-2.05-.57v.06c0 2.2 1.56 4.03 3.64 4.44-.67.2-1.37.2-2.06.08.58 1.8 2.26 3.12 4.25 3.16C5.78 18.1 3.37 18.74 1 18.46c2 1.3 4.4 2.04 6.97 2.04 8.35 0 12.92-6.92 12.92-12.93 0-.2 0-.4-.02-.6.9-.63 1.96-1.22 2.56-2.14z"/></svg>
                                        </div>
                                    </div>
                                    </a>

                                </p>
                            </ul>
                            <div v-if="dialogItem.editOwner">
                                <v-btn class="edit-btn float-right mt-6" color="primary" :to="dialogItem.editOwner">Edit</v-btn>
                            </div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-card-title class="searchbar">
            <!-- <v-spacer></v-spacer> -->
            <v-text-field
                v-model="search"
                class="searchbar__input"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
            ></v-text-field>
        </v-card-title>
        <!-- change this to dynamic -->
        <div class="data-table__key">
            <div class="item__flags">
                <button class="filter-btn filter-btn--all" :class="{ 'is-active' : !filterByFlag.length }" @click="resetFilters($event)">
                    <span><strong>{{businessesAll.length}}</strong> business listings</span>
                </button>
                <button class="filter-btn" :class="{ 'is-active' : filterByFlag.includes(1) }" @click="updateFilterByFlag(1, $event)"> 
                    <span><strong>{{businessesAll.filter(item => item.flags[1].toggle).length}}</strong> essential businesses</span> 
                    <i aria-hidden="true" class="v-icon notranslate mdi mdi-police-badge theme--light"></i>
                </button>
                <button class="filter-btn" :class="{ 'is-active' : filterByFlag.includes(2) }" @click="updateFilterByFlag(2, $event)"> 
                    <span><strong>{{businessesAll.filter(item => item.flags[2].toggle).length}}</strong> offering discounts </span>
                    <i aria-hidden="true" class="v-icon notranslate mdi mdi-sale theme--light"></i>
                </button>
                <button class="filter-btn" :class="{ 'is-active' : filterByFlag.includes(0) }" @click="updateFilterByFlag(0, $event)"> 
                    <span><strong>{{businessesAll.filter(item => item.flags[0].toggle).length}}</strong> now hiring</span> 
                    <i aria-hidden="true" class="v-icon notranslate mdi mdi-account-plus theme--light"></i>
                </button>
            </div>
        </div>
        <v-data-table
            :headers="headers"
            :items="businesses"
            :search="search"
            :loading="loading"
            :hide-default-footer="true"
            :page.sync="page"
            :items-per-page="itemsPerPage"
            @page-count="pageCount = $event"
            class="data-table"
            :mobile-breakpoint=992
        >
            <template v-slot:item.actions="{ item }">
                <v-btn class="details-btn" color="primary" @click="openDetails(item)">Details</v-btn>
            </template>
            <template v-slot:item.sector="{ item }">
                <span class="sector">{{toLower(item.sector)}}</span>
            </template>
            <template v-slot:item.status="{ item }">
                <div class="hidden-mobile">
                    <div class="item__status" :style="`background-color:${item.statusCode}`"></div>
                    <span>{{ item.status }}</span>
                </div>
            </template>
            <template v-slot:item.name="{ item }">
                <div class="item__name">
                    <span>{{ item.name }}</span>
                </div>
            </template>
            <template v-slot:item.flags="{ item }">
                <div class="item__flags">
                    <span class="visible-mobile">Extra Info</span>
                    <span v-for="flag in item.flags" :key="flag.name+Date.now()">
                        <v-tooltip bottom eager>
                            <template v-slot:activator="{ on }">
                                <v-icon v-if="flag.toggle" v-on="on">
                                    {{ flag.icon }}
                                </v-icon>
                            </template>
                            <span>
                                {{ flag.name }}
                            </span>
                        </v-tooltip>
                    </span>
                </div>
            </template>
            <template v-slot:item.details.contact.phone="{ item }">
                <div class="item__number">
                    <span class="visible-mobile">Phone</span>
                    <a :href="`tel:${item.details.contact.phone}`" target="_blank">{{item.details.contact.phone}}</a>
                </div>
            </template>
            <template v-slot:item.details.business.town="{ item }">
                <div class="item__name item__name--town">
                    <span>{{item.details.business.town}}</span>
                </div>
            </template>
            <template v-slot:item.details.contact.url="{ item }">
                <a :href="fixURL(item.details.contact.url)" target="_blank">{{fixURL(item.details.contact.url)}}</a>
            </template>
            <template v-slot:item.edit="{ item }">
                <v-btn class="edit-btn" color="primary" :to="item.edit">
                    Edit
                </v-btn>
            </template>
        </v-data-table>
        <v-pagination v-model="page" :length="pageCount" :total-visible="10"></v-pagination>
    </v-card>
    </v-container>
</template>

<script>
    export default {
        name: 'Datatable',
        data() {
            return {
                page: 1,
                pageCount: 0,
                itemsPerPage: 10,
                search: this.$route.query.business,
                dialog: false,
                loading: true,
                dialogItem: {
                    "name": "",
                    "sector": "",
                    "phone": "",
                    "url": "",
                    "editOwner": "",
                    "details": {
                        "contact": {
                            "firstname": "",
                            "lastname": "",
                            "email": "",
                        },
                        "business": {
                            "address": "",
                            "town": "",
                            "postcode": "",
                            "website": "",
                            "description": "",
                            "hours": "",
                        }
                    },
                    "flags": []
                },
                headers: [],
                businessesAll: [],
                filterByFlag: []
            }
        },
        computed: {
            vCardLogo() {
                return this.$store.getters.getvCardlogo;
            },
            businesses() {
                //check if filters are applied
                if (this.filterByFlag.length) {
                    return this.businessesAll.filter(item => {
                        let filtered = false;

                        //go throug all filterd flags and check if item has set at least one
                        this.filterByFlag.forEach(filterItem => {
                            if (item.flags[filterItem].toggle) {
                                filtered = true;
                            }
                        })

                        return filtered;
                    })
                }

                return this.businessesAll;
            }
        },
        methods: {
            openDetails(item) {
                this.dialogItem = item
                this.dialog = !this.dialog
            },
            close() {
                this.dialog = !this.dialog
            },
            toLower(str) {
                return str.toLowerCase();
            },
            fixURL(url) {
                if (!/^https?:\/\//i.test(url)) {
                    url = 'https://' + url;
                }
                return url;
            },
            encodeBusiness(business) {
                var encodedBusiness = encodeURI(business);
                console.log(encodedBusiness);
                return encodedBusiness;
            },
            updateFilterByFlag(param, event) {
                event.target.blur(); //remove focus
                //check if filter is applied
                if (this.filterByFlag.includes(param)) {
                    //apply filter to filterByFlag
                    const index = this.filterByFlag.indexOf(param);
                    this.filterByFlag.splice(index, 1);

                    return
                }

                this.filterByFlag.push(param);
            },
            resetFilters(event) {
                event.target.blur(); //remove focus
                this.search = '';
                this.filterByFlag = [];

            }
        },
        mounted() {
            this.$axios.get(this.$store.state.client_vars.DATATABLE)
                .then(response => {
                    this.businessesAll = response.data;
                    this.loading = false;
                })
                .catch(error => console.log('Failed to update from MOH', error))
            this.$axios.get(this.$store.state.client_vars.DATATABLEHEADERS)
                .then(response => {
                    this.headers = response.data
                })
                .catch(error => console.log('Failed to update from MOH', error))
        }
    }
</script>

<style lang="scss">
    $button-colours: #61aa35, #f04824, #0098a8, #ffd600, #945ca5; 
    .resp-sharing-button__link,
.resp-sharing-button__icon {
  display: inline-block
}

.resp-sharing-button__link {
  text-decoration: none;
  color: #fff;
  margin: 0.5em
}

.resp-sharing-button {
  border-radius: 5px;
  transition: 25ms ease-out;
  padding: 0.5em 0.75em;
  font-family: Helvetica Neue,Helvetica,Arial,sans-serif
}

.resp-sharing-button__icon svg {
  width: 1em;
  height: 1em;
  margin-right: 0.4em;
  vertical-align: top
}

.resp-sharing-button--small svg {
  margin: 0;
  vertical-align: middle
}

/* Non solid icons get a stroke */
.resp-sharing-button__icon {
  stroke: #fff;
  fill: none
}

/* Solid icons get a fill */
.resp-sharing-button__icon--solid,
.resp-sharing-button__icon--solidcircle {
  fill: #fff;
  stroke: none
}

.resp-sharing-button--twitter {
  background-color: #55acee
}

.resp-sharing-button--twitter:hover {
  background-color: #2795e9
}

.resp-sharing-button--pinterest {
  background-color: #bd081c
}

.resp-sharing-button--pinterest:hover {
  background-color: #8c0615
}

.resp-sharing-button--facebook {
  background-color: #3b5998
}

.resp-sharing-button--facebook:hover {
  background-color: #2d4373
}

.resp-sharing-button--tumblr {
  background-color: #35465C
}

.resp-sharing-button--tumblr:hover {
  background-color: #222d3c
}

.resp-sharing-button--reddit {
  background-color: #5f99cf
}

.resp-sharing-button--reddit:hover {
  background-color: #3a80c1
}

.resp-sharing-button--google {
  background-color: #dd4b39
}

.resp-sharing-button--google:hover {
  background-color: #c23321
}

.resp-sharing-button--linkedin {
  background-color: #0077b5
}

.resp-sharing-button--linkedin:hover {
  background-color: #046293
}

.resp-sharing-button--email {
  background-color: #777
}

.resp-sharing-button--email:hover {
  background-color: #5e5e5e
}

.resp-sharing-button--xing {
  background-color: #1a7576
}

.resp-sharing-button--xing:hover {
  background-color: #114c4c
}

.resp-sharing-button--whatsapp {
  background-color: #25D366
}

.resp-sharing-button--whatsapp:hover {
  background-color: #1da851
}

.resp-sharing-button--hackernews {
background-color: #FF6600
}
.resp-sharing-button--hackernews:hover, .resp-sharing-button--hackernews:focus {   background-color: #FB6200 }

.resp-sharing-button--vk {
  background-color: #507299
}

.resp-sharing-button--vk:hover {
  background-color: #43648c
}

.resp-sharing-button--facebook {
  background-color: #3b5998;
  border-color: #3b5998;
}

.resp-sharing-button--facebook:hover,
.resp-sharing-button--facebook:active {
  background-color: #2d4373;
  border-color: #2d4373;
}

.resp-sharing-button--twitter {
  background-color: #55acee;
  border-color: #55acee;
}

.resp-sharing-button--twitter:hover,
.resp-sharing-button--twitter:active {
  background-color: #2795e9;
  border-color: #2795e9;
}

    .item__status {
        width: 14px;
        height: 14px;
        border-radius: 3px;
        border: 1px solid #748D9A;
        display: inline-block;
        margin-right: 3px;
    }

    .searchbar {
        justify-content: center;
        padding-bottom: 0px;
    }

    .searchbar__input {
        color: #0080c5;
        max-height: 90px;
        border-radius: 16px;
        border: solid 4px rgba(151, 151, 151, 0.39);
        background-color: #ffffff;
        max-width: 600px !important;
        padding-top: 0px !important;
        position: absolute;
        top: -60px;

        input[type=text] {
            font-size: 32px;
            max-height: 100%;
            height: 100%;
            padding-left: 32px;
            color: #0080c5 !important;
        }

        label {
            font-size: 32px;
            height: 100% !important;
            line-height: 1 !important;
            padding-left: 33px;
            top: 10px !important;
            color: #0080c5 !important;
        }

        &:after {
            display: none !important;
        }

        .v-input__slot {
            &:before,&:after  {
                display: none;
            }
        }

        .v-input__append-inner {
            margin-top: 0px !important;
            width: 90px;
            height: 82px;
            background-color: #61aa35;
            border-top-right-radius: 12px;
            border-bottom-right-radius: 12px;
            cursor: pointer;

            &:focus, &:hover {
                background-color: #70c13e;
            }

            .v-input__icon {
                height: 100%;
                
                .v-icon {
                    font-size: 65px;
                    color: white !important;
                }
            }
        }
    }

    .data-table__key {
        padding: 20px 0 60px;
        text-align: center;

        .item__flags {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;

            @media (min-width: 992px) {
                -webkit-box-orient: horizontal;
                -webkit-box-direction: normal;
                -ms-flex-direction: row;
                flex-direction: row;
                -webkit-box-pack: center;
                -ms-flex-pack: center;
                justify-content: center;

                span {
                    margin-right: 5px;
                }
            }

            .hidden-mobile {
                display: none;

                @media (min-width: 992px) {
                    display: inline;
                }
            }

            span,
            button {
                text-transform: uppercase;
                //margin-right: 20px;
                color: #737373;

                &:last-child {
                    margin-right: 0;
                }
            }

            .filter-btn {
                height: 35px;
                border-radius: 5px;
                border: 2px solid #0080c5;
                transition: 0.2s all ease-in-out;
                padding: 0 15px;
                margin-top: 15px;
                display: block;

                span {
                    color: #0080c5;
                    text-transform: uppercase;
                }

                @media (min-width: 992px) {
                    margin-right: 15px;
                    margin-top: 0;
                }

                i {
                    margin-top: -2px;
                    position: relative;
                    left: 5px;
                }

                &:hover {
                    span {
                        text-decoration: underline;
                    }
                }

                
                &.is-active {
                    background-color: #0080c5;

                    span {
                        color: #ffffff;
                    }

                    i {
                        color: #fff;
                    }
                }
            }

            .filter-btn--all {
                &.is-active {
                    cursor: default;

                    &:hover {
                        span {
                            text-decoration: none;
                        }
                    }
                }
            }
        }
    }

    .data-table {
        @for $i from 1 through length($button-colours) {
            tr:nth-of-type(#{length($button-colours)}n+#{$i}) {
                .sector {
                    background-color: nth($button-colours, $i) !important;
                    border-color: nth($button-colours, $i) !important;  
                }
            }
        }

        .item__flags {
            img {
                margin-right: 5px;
            }
        }

        td {
            padding: 25px 10px !important;
            font-size: 20px !important;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #737373;

            a {
                color: #737373;
                text-decoration: none;

                &:hover, &:focus {
                    color: #0080c5;
                    text-decoration: underline;
                }
            }

            .details-btn {
                box-shadow: none;
                border-radius: 10px;
                border: solid 2px #cccccc !important;
                color: #0080c5 !important;
                background-color: #ffffff !important;
                transition: .2s all ease-in-out;
                text-transform: capitalize;
                height: 50px !important;
                float: right;

                &:hover, &:focus {
                    border-color: #0080c5 !important;
                    background-color: #0080c5 !important;
                    color: #ffffff !important;
                }
            }

            .edit-btn {
                height: 50px !important;
                border-radius: 10px;
                border: 2px solid  #0080c5 !important;
                background-color: #0080c5 !important;
                color: #ffffff !important;
                box-shadow: none;
                transition: .2s all ease-in-out;
                text-transform: none;

                 &:hover, &:focus {
                    border-color:  #cccccc !important;
                    color: #0080c5 !important;
                    text-decoration: none;
                    background-color: #ffffff !important;
                }
            }
        }

        .sector {
            padding: 0px 15px;
            border-radius: 11px;
            color: white;
            min-height: 49px;
            display: inline-flex;
            align-items: center;
            text-transform: capitalize;
            white-space: nowrap;
        }
    }

    .v-data-table-header {
        th {
            font-size: 14px !important;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #838383;
            text-transform: uppercase;
        }
    }

    .v-pagination {
        margin-top: 60px !important;

        li {
            background: none;
            padding: 0px;

            button {
                margin: 0px;
                height: 40px;
                width: 40px;
                border-radius: 0px;
                box-shadow: none;
                border-top: solid 1px #cccccc;
                border-bottom: solid 1px #cccccc;
                border-right: solid 1px #cccccc;
                color: #737373;

                &.v-pagination__item--active {
                    background-color:#61aa35 !important;
                    border-color:#61aa35 !important;
                }

                i {
                    color: #61aa35 !important;
                }
            }

            &:first-of-type {
                button {
                    border-left: solid 1px #cccccc;
                } 
            }
        }

        .v-pagination__more {
            margin: 0;
            height: 40px;
            width: 40px;
            border-right: 1px solid #ccc;
        }
    }

    .v-card {
        padding: 34px;
        box-shadow: none;

        a {
            text-decoration: none;

            &:hover {
                text-decoration: underline;
            }
        }

        h2 {
            color: #838383;
            font-size: 14px;
            text-transform: uppercase;
            font-weight: 600;
            padding-bottom: 22px;
            border-bottom: solid 1px #b0b1b2;
            margin-bottom: 35px;

            &.nested {
                margin-bottom: 24px;
                margin-top: 27px;
            }
        }

        .v-card__text {
            padding: 0px !important;
        }
    }

    .v-card-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 50px;

        .v-card__title {
            color: #0080c5;
            font-size: 32px;
            padding-left: 40px;
            margin-right: auto;
            word-break: break-word;
        }
    }

    .v-data-table__mobile-row__header {
        width: 50%;
    }

    .v-card-column-wrapper {
        display: flex;
        justify-content: space-between;

        .v-card-column {
            width: 47%;

            li {
                background-position: left;
                padding-left: 40px;
                background-size: 20px; 
                background-repeat: no-repeat;

                &.contact-name {
                    background-image: url(/__data/assets/file/0014/2147/ic-actions-user.svg);
                }
                &.contact-email {
                    background-image: url(/__data/assets/file/0015/2148/ic-contact-mail.svg);
                }
                &.contact-phone {
                    background-image: url(/__data/assets/file/0016/2149/ic-contact-phone.svg);
                }
                &.contact-url {
                    background-image: url(/__data/assets/file/0008/2150/ic-devices-laptop.svg);
                }
                &.contact-location {
                    background-image: url(/__data/assets/file/0009/2151/ic-contact-map-pin.svg);
                    background-size: contain;
                }
                &.contact-hours {
                    background-image: url(/__data/assets/file/0010/2152/ic-ecommerce-house.svg);
                    background-position: top left;
                }
            }
        }
    }

    .v-card-close {
        width: 40px !important;
        height: 40px !important;
        min-width: 0px !important;
        background-color: transparent !important;
        box-shadow: none !important;

        &:hover, &:focus {
            background-color: transparent !important;
        }
    }

    .flag-icons {
        display: flex;
        justify-content: space-between;
        flex-direction: column;

        div {
            &:empty {
                display: none;
            }
        }
    }

    @media only screen and (max-width: 600px) {
        .v-card-column-wrapper {
            flex-wrap: wrap;
            .v-card-column {
                width: 100%;
            } 
        }
        .v-card-header {
            img {
                display: none;
            }
            .v-card__title {
                padding-left: 0px;
            }
        }
    }    

    .visible-mobile {
        display: none;
    }

    .v-data-table {
        .v-data-table-header-mobile {
            background-color: #0481c6;
            border-radius: 10px;

            th {
                border-radius: 10px;
            }

            .v-text-field > .v-input__control > .v-input__slot:before {
                border-color: transparent;
            }

            .v-text-field:not(.v-input--has-state):hover > .v-input__control > .v-input__slot:before {
                border-color: transparent;
            }

            .v-input input, .theme--light.v-input textarea {
                color: white;
            }

            .v-input input:placeholder {
                color: white;
            }

            .v-label {
                color: white;
                line-height: 16px;
            }

            .v-input__icon {
                i {
                    color: white;
                }
            }

            .v-text-field .v-input__prepend-inner, .v-text-field .v-input__append-inner {
                margin-top: 0;
            }
        }

        .v-data-table__mobile-table-row {
            display: block;
            border: 2px solid #ccc;
            border-radius: 10px;
            margin: 20px 0;

            &:hover {
                background-color: white !important;
            }
        }

        .v-data-table__mobile-row {
            text-align: center;
            padding: 6px 0 !important;
            position: relative;

            &:first-child {
                min-height: 0 !important;
            }

            &:last-child {
                padding-bottom: 0 !important;
                border-top: 1px solid #ccc;
            }

            .v-data-table__mobile-row__header {
                display: none;
            }

            .v-data-table__mobile-row__cell {
                text-align: center;
                margin: 0 auto;
                display: inline-block;
                width: 100%;

                .hidden-mobile {
                    display: none;
                }

                .visible-mobile {
                    display: block;
                }

                .sector {
                    font-size: 14px;

                }

                .item__name {
                    font-size: 18px;
                    font-weight: bold;
                    color: #4a4a4a;
                    margin: 5px 0 15px;
                }

                .item__number, .item__flags {
                    position: absolute;
                }

                .item__number {
                    left: 0;
                    right: 50%;
                    top: 0;
                    background-color: #f4f4f4;
                    padding: 10px 20px;
                    text-align: left;
                    height: 69px;
                    font-size: 14px;
                    font-weight: 600;
                    text-transform: uppercase;

                    span {
                        margin-bottom: 8px;
                    }

                    a {
                        font-size: 16px;
                    }
                }

                .item__flags {
                    right: 0;
                    top: -48px;
                    left: 50%;
                    background-color: #f4f4f4;
                    padding: 10px 20px;
                    height: 69px;
                    text-align: right;
                    font-size: 14px;
                    font-weight: 600;
                    text-transform: uppercase;

                    span:first-of-type {
                        margin-bottom: 6px;
                    }
                }

                .v-btn {
                    width: 100%;
                    background-color: white !important;
                    color: #0080c5 !important;
                    border: 0 !important;
                    font-size: 16px;
                    font-weight: 600;
                    margin-top: -30px;
                }
            }
        }
    }

    @media (min-width: 992px) and (max-width:1903px) {
        .container {
           max-width: 1250px;
           max-width: 1785px;
        }
        .item__name--town {
            min-width: 110px;
        }
        .item__number {
            min-width: 115px;
        }
     }
 </style>